<template>
  <custom-btn-icon
    @click.stop.prevent="handleClick"
    :color="color"
    :icon="generateMessagePath('icon')"
    :outlined="isOutlined"
    :text="hasLabel ? generateMessagePath(`title`) : ''"
    :tooltip-text="hasTooltip ? generateMessagePath(`title`) : ''"
  >
    <div v-if="isBtnText || hasLabel">{{ generateMessagePath(`title`) }}</div>
  </custom-btn-icon>
</template>
<script>
import CustomBtnIcon from '@/components/displays/CustomBtnIcon';
import { generateMessage } from '@/utils/i18n';
import { mapActions } from 'vuex';

export default {
  name: 'CustomFormBtnDialog',
  components: { CustomBtnIcon },
  props: {
    color: { type: String, required: false, default: 'blue-venice' },
    hasLabel: { type: Boolean, required: false },
    i18nPath: { type: String, required: false },
    isBtnText: { type: Boolean, default: false },
    isEditing: { type: Boolean, default: false },
    isOutlined: { type: Boolean, default: false },
    modalProps: { type: Object, required: false },
    hasTooltip: { type: Boolean, default: true },
  },
  methods: {
    ...mapActions('modal', ['showModal']),
    generateMessage,
    generateMessagePath(key) {
      return this.generateMessage(
        `${this.i18nPath}.${this.isEditing ? 'update' : 'create'}.${key}`
      );
    },
    handleClick() {
      this.showModal(this.modalProps);
    },
  },
};
</script>
